import styled from 'styled-components'

import Flex from 'Components/Flex'
import AppButton from 'Components/AppButton'
import PlaceHolder from 'Components/PlaceHolder'

import {
  SELECTED_ITEM_BG_COLOR, GREY_BACKGROUND, OUTLINE_COLOR, SITE_NAVY_COLOR,
} from '@CSSVars/colors'


export const _AreaBoxContainer = styled(Flex)`
  width: auto !important;
  display: inline-flex !important;
  > div {
    &:first-child {
      margin-left: 0;
    }
  }
`

export const _AreaBox = styled.button`
  z-index: 100;
  position: relative;
  background-color: ${({ isSelected }) => (isSelected ? SELECTED_ITEM_BG_COLOR : 'white')};
  height: 64px;
  line-height: 22px;
  margin: 0 6px 0 0;
  padding: 12px 24px;
  white-space: nowrap;
  width: auto !important;
  min-height: 64px;
  border: 1px solid ${OUTLINE_COLOR};
  box-sizing: border-box;
  border-radius: 10px;
  ${({ childrenSelected, isSelected }) => (childrenSelected || isSelected ? `
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
      ` : '')}
  > div {
    line-height: 22px;
    color: ${({ isSelected }) => (isSelected ? 'white' : 'inherit')};
    border-bottom-right-radius: 0;

    ${({ isSelected }) => (isSelected ? `
          &:first-child {
            font-size: 14px;
            margin-top: 4px;
            font-weight: 500;
          }
        ` : '')}
  }

  &:hover {
    border: 1px solid ${SELECTED_ITEM_BG_COLOR};
    cursor: pointer;
  }
`

export const _NeighbourhoodCount = styled.div`
  font-size: 12px;

  span {
    color: white;
  }
`

export const _AreaBoxCloseIcon = styled.div`
  position: absolute;
  right: 8px;
  top: 0;
  line-height: 0;
  svg {
    fill: white;
  }
`

export const _ViewMoreChildren = styled(AppButton)`
  width: 30px;
  background: ${GREY_BACKGROUND} !important;
  border: 1px solid ${OUTLINE_COLOR};
  border-left: none;
  height: 64px;
  margin-right: 4px;
  margin-left: -6px;
  padding: 0;

  &:hover {
    cursor: pointer;
  }
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  ${({ currentlyActiveArea }) => (
    currentlyActiveArea ?
      `

        svg {
          transform: rotate(180deg);
        }
      ` : ''
  )}
`

export const _SelectedChildCount = styled(Flex)`
  width: 100%;
  height: 25px;
  margin-top: -18px;
  background: ${SITE_NAVY_COLOR};
  border-top-right-radius: 10px;
  > span {
    color: white;
    text-decoration: none !important;
  }

  + div {
    margin-top: 4px;
  }
`

export const _DiscoveryAreaBoxes = styled(Flex)`
  margin: 12px 0 16px 0;
  position: relative;

  && {

    .embla {
      position: static;
    }

    .embla__slide {
      width: auto;
      flex-shrink: 0;
    }

    .embla__button {
      &:disabled {
        display: none;
      }
    }

    .embla__button--prev {
      left: -12px !important;
    }

    .embla__button--next {
      right: -12px !important;
    }
  }

`

export const _AreaBoxPlaceHolder = styled(PlaceHolder)`
  height: 64px;
  width: 120px;
  margin-right: 8px !important;
`
